import { ConfirmReservationAction } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import ReservationConfirmationResult from '@/models/interfaces/ReservationConfirmationResult';

import TimestampPayload from '../TimestampPayload';

export interface ConfirmReservationPayload {
  token: string;
  action: ConfirmReservationAction;
}
export const confirmReservation = createAction<ConfirmReservationPayload>('CONFIRM_RESERVATION');
export type ConfirmReservationActionType = Action<ConfirmReservationPayload>;

export interface ReservationConfirmationResultPayload extends TimestampPayload {
  reservationConfirmationResult: ReservationConfirmationResult;
  token: string;
}
export const reservationConfirmationFinished = createAction<ReservationConfirmationResultPayload>('RESERVATION_CONFIRMATION_FINISHED');
export const reservationConfirmationFailed = createAction<ReservationConfirmationResultPayload>('RESERVATION_CONFIRMATION_FAILED');
